export const state = {
  items: [],
  details: null,
  crops: [],
  bosses: [],
  meta: null,
  config: null,
  query: "",
  ready: false,
};

export const CART_KEY = "ck-craft-cart-v1";
